import React, {useMemo} from "react"
import {SchoolClass, SchoolClassCheckIn} from "models"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import MoodAverage from "components/score-factor-groups/mood-average"
import MoodSimpleLineChart from "components/score-factor-groups/mood-simple-line-chart"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import useDates from "components/utils/use-dates"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsUserSchoolClassesInsightsMoodChartSlide extends ShapeComponent {
  static propTypes = propTypesExact({
    dateFrom: PropTypes.instanceOf(Date).isRequired,
    dateTo: PropTypes.instanceOf(Date).isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {l} = useDates()
    const {t} = useI18n({namespace: "js.routes.user.school_classes.insights"})

    this.setInstance({l, t})
    this.useStates({
      lastSchoolClassCheckIn: undefined,
      schoolClassCheckInsQuery: undefined
    })

    useMemo(() => {
      this.loadLastSchoolClassCheckIn()
    }, [])
  }

  async loadLastSchoolClassCheckIn() {
    const {schoolClass} = this.p
    const lastSchoolClassCheckIn = await SchoolClassCheckIn
      .ransack({
        s: "created_at DESC",
        school_class_id_eq: schoolClass.id(),
        state_eq: "closed"
      })
      .select({SchoolClassCheckIn: ["createdAt", "id"]})
      .first()

    this.setState({
      lastSchoolClassCheckIn,
      schoolClassCheckInsQuery: SchoolClassCheckIn.ransack({id_eq: lastSchoolClassCheckIn?.id() || "no-last-school-class-check-in-fake-uuid"})
    })
  }

  render() {
    const {dateFrom, dateTo, schoolClass} = this.p
    const {lastSchoolClassCheckIn, schoolClassCheckInsQuery} = this.s
    const {l} = this.tt
    const moodCircleActive = Boolean(lastSchoolClassCheckIn)

    return (
      <View dataSet={{component: "user--school-classes--insights--mood-class-slide"}}>
        <div className="grid grid-gap-10 grid-cols-3" style={{width: "100%"}}>
          <div className="col-span-1 col-span-xl-1">
            {schoolClassCheckInsQuery &&
              <MoodAverage
                className="three-latest-woofs-mood-average"
                defaultAverage={moodCircleActive ? undefined : 3.0}
                schoolClassCheckInsQuery={schoolClassCheckInsQuery}
                subTitle={l(lastSchoolClassCheckIn?.createdAt(), "date-long")}
              />
            }
          </div>
          <div className="col-span-1 col-span-xl-2">
            {schoolClass &&
              <MoodSimpleLineChart dateFrom={dateFrom} dateTo={dateTo} schoolClass={schoolClass} />
            }
          </div>
        </div>
      </View>
    )
  }
}))
